var exports = {
  "qG": "fadeIn__N1M24t",
  "az": "Box__Zc8a5a",
  "wy": "Box_1__a7Ye8o",
  "re": "GitHubAvatar__My0PQ2",
  "pv": "Box_2__rGqIBv",
  "w9": "Box_3__PAb3uO",
  "pQ": "Box_4__BJmI5V",
  "$c": "CounterLabel__x2PAA5",
  "ky": "smallCounterLabel__KfgSDH",
  "_2": "StyledAvatarBox__AcT6yz",
  "dl": "StyledAvatar__oI8yyu",
  "PZ": "idleStyledAvatar__U4BUAC",
  "kS": "StyledCounter___jlMfI",
};

module.exports = exports;
